<template>
  <h2>
    <slot>Subhead fitting goes here</slot>
  </h2>
</template>

<script>
export default {
  name: "SubheadFitting",
};
</script>

<style scoped lang="scss">
</style>
